<template>
    <div class="cf" v-if="totalPoints">
        <small>Ukupni rezultat</small>
        <template v-if="!error">
            <template v-if="totalPoints && totalPoints.loaded">
                <span>
                    <b>{{ totalPoints.points }}</b>
                    Bodova
                </span>
                <span>
                    <i>{{ totalPosition }}</i>
                    Pozicija
                </span>
            </template>
            <template v-else>
                <p>Učitavanje rezultata</p>
            </template>
        </template>
        <template v-if="error">
            <p class="error">{{ error }}</p>
        </template>
    </div>
</template>

<script>
import { ResultType } from '../utils/ResultType'
import { ApplicationState } from '../application-state'
export default {
    name: 'prev-round-score',
    data () {
        return {
            error: null
        }
    },
    methods: {
        async initialLoadData () {
            try {
                await this.$db.results.getUserResultFor(ResultType.Total, undefined, this.uid)
            } catch (error) {
                this.error = error.message
            }
        }
    },
    watch: {
        appState (after, before) {
            if (before === ApplicationState.LOADING_DATA) {
                this.initialLoadData()
            }
        }
    },
    computed: {
        appState () {
            try {
                return this.$store.state.appState
            } catch (error) { }
            return ApplicationState.LOADING_DATA
        },
        totalPoints () {
            return this.$store.state.points.total
        },
        totalPosition () {
            try {
                return this.$store.state.points.total.position.toString().padStart(4, '0')
            } catch (error) { }
            return false
        }
    },
    mounted () {
        if (this.appState !== ApplicationState.LOADING_DATA) {
            this.initialLoadData()
        }
    }
}
</script>

<style lang="scss" scoped>
div {
    box-shadow: 0px 18px 24px 0px rgba(0,0,0,0.34);
    padding: 16px 14px 14px;
    background-color: #fff;
    color: #000;
    border-radius: 10px;
    height: 100%;
    min-width: 150px;

    small {
        display: block;
        float: left;
        width: 100%;
        font-size: inherit;
    }
    span {
        text-align: center;
        font-family: "axiforma";
        text-transform: uppercase;
        font-size: 10px;
        letter-spacing: 1px;
        color: #adadae;
        margin-top: 10px;
    }
    b {
        display: block;
        font-family: "mPlus";
        font-size: 18px;
        line-height: 26px;
        letter-spacing: -.2px;
        color: #000;
    }
    i {
        display: block;
        color: #fff;
        background-color: #12385d;
        border-radius: 6px;
        padding: 5px 0px;
        font-size: 10px;
        margin-bottom: 6px;
    }
    span:nth-child(2) {
        text-align: left;
        float: left;
    }
    span:nth-child(3) {
        float: right;
    }
    .error {
        padding-top: 15px;
        text-align: right;
        font-weight: 800;
        font-size: 18px;
        line-height: 24px;
        margin-bottom: 0;
    }
}
</style>
